const _sfc_main = {
  name: "ArrowLeft"
};
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  fill: "currentColor",
  d: "M381.8344866 512l349.81981623 349.81981621c32.54137884 32.54137884 32.54137884 81.35344611-1e-8 113.89482308-32.54137884 32.54137884-81.35344611 32.54137884-113.89482304-3e-8l-406.76722873-406.76722677c-32.54137884-32.54137884-32.54137884-81.35344611 0-113.89482498l406.76722873-406.76722677c32.54137884-32.54137884 81.35344611-32.54137884 113.89482304-1e-8 32.54137884 32.54137884 32.54137884 81.35344611 1e-8 113.89482306l-349.81981623 349.81981621z"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ _createElementVNode("path", {
  fill: "currentColor",
  d: "M381.8344866 512l349.81981623 349.81981621c32.54137884 32.54137884 32.54137884 81.35344611-1e-8 113.89482308-32.54137884 32.54137884-81.35344611 32.54137884-113.89482304-3e-8l-406.76722873-406.76722677c-32.54137884-32.54137884-32.54137884-81.35344611 0-113.89482498l406.76722873-406.76722677c32.54137884-32.54137884 81.35344611-32.54137884 113.89482304-1e-8 32.54137884 32.54137884 32.54137884 81.35344611 1e-8 113.89482306l-349.81981623 349.81981621z"
}, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "arrow-left.vue"]]);
